import { action } from 'satcheljs';
import { Todo } from 'owa-todo-types';

export const preloadTaskPanelData = action('PRE_LOAD_TODO_PANEL_DATA');

export const initializeQuickAdd = action(
    'initializeQuickAdd',
    (subject: string, linkedEmailEwsId?: string, extractionId?: string) => ({
        subject,
        linkedEmailEwsId,
        extractionId,
    })
);

/**
 * This switches the folder to the folder specified by folderId. If there is no folderId provided, and we can create tasks in the the currently selected folder view,
 * then we do not switch folders. If we cannot create tasks in the current folder view, we switch to the default
 * folder.
 */
export const switchFolderAndCreateTasks = action(
    'switchFolderAndCreateTasks',
    (todos: Partial<Todo>[], folderId?: string) => ({
        todos,
        folderId,
    })
);
